'use client';

import { useEffect, useRef } from 'react';
import { coverPaletteFromImage } from '../lib/heroes/cover-palette';

export default function CatalogDetailTheme({ image }: { image: string }) {
  const marker = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const shell = marker.current?.closest<HTMLElement>('.v2-shell');
    if (!shell || !image) return;
    let active = true;
    void coverPaletteFromImage(image).then((palette) => {
      if (!active || !palette) return;
      shell.style.setProperty('--catalog-base', palette.base);
      shell.style.setProperty('--catalog-end', palette.end);
      shell.style.setProperty('--catalog-glow', palette.glow);
      shell.style.setProperty('--catalog-accent', palette.accent);
      shell.classList.add('has-catalog-palette');
    });
    return () => { active = false; };
  }, [image]);

  return <span ref={marker} hidden aria-hidden="true" />;
}
